import type { FaireProductEntity } from "../../entity_types/product";

export const p_4sbrh9mp6y: FaireProductEntity = {
  token: "p_4sbrh9mp6y",
  type: "product",
  name: "The Beautiful Release Bundle",
  brandToken: "b_4pa4ck0idd",
  brandName: "Soul Hum Non-Alcoholic Elixirs",
  imageUrl:
    "https://cdn.faire.com/fastly/cae56db8d74a26ea212f9d8c0a76d31f6cddb3af4e072175e3f7dbf838efd983.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fd79c36b53341ff9ba5ff87f3c547f04c0bff1474653fe5dde075e0eca745df0.png",
    "https://cdn.faire.com/fastly/ef165f3648b491b8dee52703e3a76a98dcd59af37bba58b92c83e486b10b4bde.png",
    "https://cdn.faire.com/fastly/a0b4e376c1ec889c723c72ba30a2ddd1ed3ac5c39cd82d2f0d79a582aa6d55c7.jpeg",
  ],
  priceDollars: 38.95,
  description:
    "The Beautiful Release\n\nA ritual for softening, letting go, and returning to yourself.\n\nThe Beautiful Release is a thoughtfully curated bundle designed to support your moments of pause, reflection, and gentle unwinding. Featuring our Soul Hum Unwind Elixir, paired with Dappled Floral Tonic Water and High Street Tonics Mellow Rose Tonic, this collection brings together calming botanicals and layered floral notes to create a deeply soothing drinking experience.\n\nAt the heart of this ritual is Unwind—crafted with adaptogens and aromatic terpenes to help ease tension, quiet the mind, and invite relaxation. When paired with delicate rose, chamomile, and hibiscus-forward tonics, each sip blooms with soft florals, subtle bitterness, and a grounding finish that lingers beautifully.\n\nThis is more than a beverage—it’s a moment.\nA chance to exhale.\nTo release what no longer serves you.\nTo return to your natural rhythm.\n\nWhat’s Included\n\n * Soul Hum Unwind Elixir (750 ml) \n * 2 × Dappled Floral Tonic Water (12 oz cans) \n * 1 × High Street Tonics Mellow Rose Tonic (8 oz) ",
  tags: [],
  msrpDollars: 102.53,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:45.727Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
